import React, { useContext, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../util/axios";
import { Context } from "../../component/Context/ErrorContext";
import { VscLoading } from "react-icons/vsc";

const ResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const { setError } = useContext(Context);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({
        contact_email: "",
        newPassword: "",
        confirmPassword: "",
    });

    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.currentTarget;
        setData((prev) => ({ ...prev, [id]: value }));
    };

    const submitHandler = (e: React.FormEvent) => {
        e.preventDefault();
        if (
            data.contact_email === "" ||
            data.newPassword === "" ||
            data.confirmPassword === ""
        ) {
            setError("Please fill all fields");
            return;
        }
        if (data.newPassword !== data.confirmPassword) {
            setError("Passwords do not match");
            return;
        }
        setLoading(true);
        axios({
            URL: "/omw/subAdmin/reset-password",
            method: "POST",
            data: {
                token: token,
                newPassword: data.newPassword,
                contact_email: data.contact_email,
            },
        })
            .then((res: any) => {
                if (res.data && res.data.status) {
                    alert(
                        res.data.message || "Password reset successful. Please login."
                    );
                    navigate("/login");
                } else {
                    setError(res.data.message || "Something went wrong.");
                }
            })
            .catch((e) => {
                setError(e.response?.data?.message || "Something went wrong.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div>
            <div
                className={
                    "w-screen h-screen flex justify-center bg-gradient-to-t from-[#305FAA] to-[#17366D]"
                }
            >
                <div
                    className={"flex flex-col w-full max-w-[1000px] pt-4 items-center"}
                >
                    <img
                        src={"/logo.png"}
                        alt="logo"
                        width={130}
                        className={"self-start"}
                    />
                    <div
                        className={
                            "flex flex-col flex-1 w-full justify-start items-center pt-32 max-w-[500px] px-4"
                        }
                    >
                        <p
                            className={"text-4xl text-white font-light text-center uppercase"}
                        >
                            CREATE NEW PASSWORD
                        </p>
                        <form
                            className={"w-full gap-5 mt-10 flex flex-col"}
                            onSubmit={submitHandler}
                        >
                            <div className={"w-full flex flex-col items-start"}>
                                <label
                                    htmlFor={"contact_email"}
                                    className={"text-white text-[1.125rem] font-bold"}
                                >
                                    EMAIL
                                </label>
                                <input
                                    id={"contact_email"}
                                    className={
                                        "bg-white w-full rounded-[4px] p-2 outline-none h-12"
                                    }
                                    onChange={onChangeHandler}
                                    value={data.contact_email}
                                    disabled={loading}
                                    type={"email"}
                                />
                            </div>
                            <div className={"w-full flex flex-col items-start"}>
                                <label
                                    htmlFor={"newPassword"}
                                    className={"text-white text-[1.125rem] font-bold"}
                                >
                                    NEW PASSWORD
                                </label>
                                <input
                                    id={"newPassword"}
                                    className={
                                        "bg-white w-full rounded-[4px] p-2 outline-none h-12"
                                    }
                                    onChange={onChangeHandler}
                                    value={data.newPassword}
                                    disabled={loading}
                                    type={"password"}
                                />
                            </div>
                            <div className={"w-full flex flex-col items-start"}>
                                <label
                                    htmlFor={"confirmPassword"}
                                    className={"text-white text-[1.125rem] font-bold"}
                                >
                                    CONFIRM NEW PASSWORD
                                </label>
                                <input
                                    id={"confirmPassword"}
                                    className={
                                        "bg-white w-full rounded-[4px] p-2 outline-none h-12"
                                    }
                                    onChange={onChangeHandler}
                                    value={data.confirmPassword}
                                    disabled={loading}
                                    type={"password"}
                                />
                            </div>
                            <div className={"w-full flex items-center justify-center mt-4"}>
                                <button
                                    className={
                                        "bg-[#43CB49] px-5 py-1 rounded text-white text-xl h-12 w-80 flex justify-center items-center hover:bg-[#3d9c41]"
                                    }
                                    type={"submit"}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <VscLoading className={"animate-spin text-2xl"} />
                                    ) : (
                                        "Reset Password"
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
